/*
*###############################################################################
*Module Name                   : ProcessContent.js                             #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : Isuru Sampath Arandara                        #
*Date                          : Monday, January 08th 2024, 1:19:43 Pm         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import DPDropDown from "framework/components/DPDropDown"
import DPTextBox from "framework/components/DPTextBox"
import React, { useEffect, useState } from "react"

import {
  Col,
  Row,
  Button,
  Table,
  Alert
} from "reactstrap"

const ProcessContent = ({

  disabled,
  SetLocMainLoc,
  locMainLoc,
  mainCode,
  prcCode,
  mainPrcCode,
  setMainPrcCode,
  setDateChange,
  dateChange,
  show,
  AlertMsg,
  AlertColor,
  ErrorMsg,

}) => {

  return (
    <React.Fragment>
      <Row>
        {show ? (
          <Alert color={AlertColor} role="alert">
            {AlertMsg}
            <br />
            <small>{ErrorMsg}</small>
          </Alert>
        ) : null}
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            labelText={"Process *"}
            optionGroup={prcCode}
            selectedGroup={mainPrcCode}
            onChange={setMainPrcCode}
            disabled={disabled}
          />

          <DPDropDown
            labelText={"Location *"}
            optionGroup={mainCode}
            selectedGroup={locMainLoc}
            onChange={SetLocMainLoc}
            disabled={disabled}
          />
          <DPTextBox
            labelText={"Date *"}
            value={dateChange}
            textType="date"
            onChange={setDateChange}
            disabled={disabled}
          />
        </Col>
      </Row >
    </React.Fragment >
  )
}
export default ProcessContent